/* blair-atc-price.js - Blair Skincare
 *
 * Writes the price shown inside the Add to bag button.
 *
 * Why this file exists
 * --------------------
 * assets/theme.dev.js > updateAddToCartState() built the button price like this:
 *
 *     let x = +"$" + variant.price
 *     x = x.substring(0, x.length - 2) + "." + x.substring(x.length - 2)
 *
 * The stray unary plus in front of "$" evaluates to NaN, so x is a Number and
 * x.substring is not a function. That branch runs only when the selected variant
 * has a compare-at price, so the exception aborted the update and the button kept
 * the previously rendered price - e.g. Hydrating Biocellulose Mask stayed at
 * $20.00 with 6 Masks selected. The same block also read the crossed-out figure
 * from variant.price instead of variant.compare_at_price.
 *
 * snippets/custom-product-buttons.liquid now marks the button label with
 * data-atc-price-text instead of data-add-to-cart-text, so the theme version no
 * longer targets it (and no longer throws), and this file writes the label
 * instead. Behaviour matches the original except:
 *
 *   - money is formatted with the theme money format rather than a hardcoded "$"
 *   - the crossed-out figure comes from compare_at_price
 *   - the "has a subscription" test is per VARIANT, not per product, so a variant
 *     with no plan shows its price while a variant with a plan stays plain and
 *     lets the Skio plan picker show the price, as before
 *
 * Nothing in theme.dev.js was modified. If that bundle is ever corrected at
 * source, delete this file and restore data-add-to-cart-text in the snippet.
 *
 * Holiday Sale: window.BlairHoliday.variants (filled in by snippets/product-price.liquid)
 * maps variant id -> { s: sale price in cents, r: original price in cents }. When the
 * selected variant is in that list the button shows the original crossed out and the
 * sale price.
 */
(function () {
  if (window.__blairAtcPrice) return;
  window.__blairAtcPrice = true;

  var SELECTOR = "[data-atc-price-text]";

  function strings() {
    return (window.theme && window.theme.strings) || {};
  }

  function format() {
    var t = window.theme || {};
    return t.moneyFormat || t.moneyWithoutCurrencyFormat || "${{amount}}";
  }

  function money(cents) {
    if (cents === null || cents === undefined || cents === "") return "";
    if (window.themeCurrency && typeof window.themeCurrency.formatMoney === "function") {
      return window.themeCurrency.formatMoney(cents, format());
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format());
    }
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function hasPlan(variant) {
    return !!(variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length);
  }

  function labelFor(el) {
    return el.getAttribute("data-atc-label") || strings().addToCart || "Add to bag";
  }

  function holidayFor(variant) {
    var h = window.BlairHoliday && window.BlairHoliday.variants;
    return h && variant ? h[String(variant.id)] : null;
  }

  function write(root, formState) {
    var nodes = root.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    var variant = formState && formState.variant;
    var s = strings();

    Array.prototype.forEach.call(nodes, function (el) {
      if (!variant) {
        el.innerHTML = s.unavailable || "";
        return;
      }

      var label = labelFor(el);

      if (!variant.available) {
        el.innerHTML = (s.soldOut || "Sold Out") + " | " + money(variant.price);
        return;
      }

      if (hasPlan(variant)) {
        el.innerHTML = label;
        return;
      }

      var hs = holidayFor(variant);
      if (hs) {
        el.innerHTML =
          label +
          " | <span class='crossout-price'>" +
          money(hs.r) +
          "</span> " +
          money(hs.s);
        return;
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        el.innerHTML =
          label +
          " | <span class='crossout-price'>" +
          money(variant.compare_at_price) +
          "</span> " +
          money(variant.price);
        return;
      }

      el.innerHTML = label + " | " + money(variant.price);
    });
  }

  function patch() {
    var ctor = window.customElements && window.customElements.get("product-form");
    if (!ctor || !ctor.prototype) return;

    var original = ctor.prototype.updateAddToCartState;
    if (typeof original !== "function" || original.blairPatched) return;

    function patched(formState) {
      original.call(this, formState);
      try {
        write(this.container || this, formState);
      } catch (e) {
        /* Leave the server-rendered price in place rather than show a wrong one. */
        if (window.console && window.console.warn) {
          window.console.warn("[blair-atc-price]", e);
        }
      }
    }

    patched.blairPatched = true;
    ctor.prototype.updateAddToCartState = patched;
  }

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined("product-form").then(patch, function () {});
  }
})();